// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetBackOrdersApiParameter } from "@store/Framework/Services/BackOrderService";
import BackOrdersState from "@store/Framework/Store/Store/Pages/BackOrders/BackOrdersState";
import { Draft } from "immer";

const initialState: BackOrdersState = {
    getBackOrdersParameter: {},
};

const actions = {
    "Pages/BackOrders/UpdateSearchFields": (
        draft: Draft<BackOrdersState>,
        action: { parameter: GetBackOrdersApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getBackOrdersParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getBackOrdersParameter = { ...initialState.getBackOrdersParameter, ...action.parameter };
        } else {
            draft.getBackOrdersParameter = { ...draft.getBackOrdersParameter, ...action.parameter };

            const skipProperties: (keyof GetBackOrdersApiParameter)[] = [];
            const skipPropertiesSet = new Set(skipProperties.map(o => o.toString()));
            for (const key in draft.getBackOrdersParameter) {
                const value = (<any>draft.getBackOrdersParameter)[key];

                if (skipPropertiesSet.has(key)) {
                    continue;
                }

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getBackOrdersParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getBackOrdersParameter.page &&
                    draft.getBackOrdersParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getBackOrdersParameter.page = 1;
                }
            }
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BackOrdersActions = Parameters<typeof reducer>[1];
export default reducer;
